import { env } from '../env/env';
export const legacyC2foAdminUiConfig = {
    LEGACY_C2FO_ADMIN_UI_URL: env.getString('LEGACY_C2FO_ADMIN_UI_URL') || 'http://localhost:8088',
};
//# sourceMappingURL=legacyC2foAdminUiConfig.js.map